module.exports = __webpack_public_path__ + "static/img/logo-hei.b00548a7.b00548a7.png";